const dicText_jp = {
  menu: {
    home: "ホーム",
    services: "サービス",
    ability: "テックスタック",
    works: "製品",
    company: "会社情報",
    contact: "お問い合わせ",
  },
  home: {
    intro_1:
      " 0 と1 の情報の世界で、無限の可能性を切り拓こう。<br />既存のデータを収集し、<br />新たなデータを生成し、<br />関連データを見つけ出し、<br />データを活用して価値を創造しよう。",
  },
  works: {
    main_title: "Works & Case",
    sub_title: "",
    data_hub_x: {
      title: "DataHubX",
      desc: "さまざまな異種データ、Excelファイル、CSVファイル、PDFファイル、およびさまざまなデータベースを柔軟に収集します。データは統一のフォーマットに抽出、変換され、データベースに保存され、その後のデータ処理、ビッグデータ分析、データ可視化、および統計レポート生成を提供します。",
    },
    strgy_master_pro: {
      title: "StrategyMasterPro",
      desc: "取引ストラテジーの開発プラットフォーム。株式、先物、外国為替、貴金属、仮想通貨など、取引対象は幅広くカバーします。トレードアイデアの視覚化、量的戦略の品質評価、取引シグナルとポジション管理の実現、およびさまざまな取引プラットフォームへの接続が可能です。",
    },
    flex_flow: {
      title: "FlexFlow",
      desc: "カスタマイズ可能なワークフローシステム。複数のプラットフォームでのデータ提出、承認、および審査に使用できるだけでなく、日常業務の経費や出勤などの承認にも利用できます。",
    },
    flex_trading_2: {
      title: "FlexTrading2",
      desc: "トレンドと振動市場のモードを自動的に切り替え、低リスクの条件下で安定した予測可能な収益を得るための量化自動取引戦略セット。",
    },
    customer_ims: {
      title: "顧客管理システム",
      desc: "顧客情報・使用量・電気料金を管理する顧客管理システムです。小売電気事業者様における顧客情報の管理や需給状況の確認、需要家様における使用量の見える化や料金確認機能をご提供します。",
    },
    power_drm: {
      title: "需給管理システム",
      desc: "電力需要予測・電源調達・計画作成を管理する需給管理システムです。AI需要予測、同時同量監視、小売・発電・FIT特例１ポジション、計画提出、JEPXスポットと時間前入札などのフルパッケージ機能をご提供します。",
    },
    power_futures: {
      title: "電力現物・先物管理システム",
      desc: "電力現物取引とそれに付随するデリバティブ取引を管理するコモディティ取引・リスク管理システムです。電力の現物・先物取引・売買管理で生じるポジション管理について、正確かつ効率的に処理することが可能です。",
    },
    power_drs: {
      title: "デマンドレスポンスシステム",
      desc: "電力需要家から実際に使用した電力を収集し、あらかじめ設定したベースラインをクリアしたかを判断するシステムです。需要家へ節電の通知、インセンティブの計算、レポートの抽出を実現します。",
    },
  },
  services: {
    main_title: "Services",
    sub_title:
      "データ分析と処理を中心に、上流および下流のコンサルティングと開発実施を提供しています。",
    data_hub: {
      title: "データ連携・統合基盤の構築",
      desc: "オンプレミスやクラウド環境に分散するデータを管理し、統合ソリューションを導入することで、社内外の様々なシステムのデータ連携を実現します。 様々なフォーマットのデータを収集して、連携先のシステムに適したフォーマットに加工・出力します。",
    },
    algorithms: {
      title: "データ分析・アルゴリズム実装",
      desc: "データのクレンジングから分析アルゴリズムの構築まで展開し、データ分析を通じて構築されたアルゴリズムをシステムに実装します。多因子時系列アルゴリズムの開発、金融取引戦略の実装、および自動取引システムの構築を提供します。",
    },
    system_dev: {
      title: "受託開発・運用・保守支援",
      desc: "データ処理システムの新規開発、既存システムの改修などサービスを提供しています。システムのホスティング、システムを監視して安定運転を確保することを行います",
    },
    power_system: {
      title: "電力需給調整・情報管理",
      desc: "送配電網の電圧と周波数を監視し、蓄電キャビネットの充放電を制御して、電網の安定供給を実現するソリューションを提供します。調整力市場に入札、清算システムも提供し、顧客登録から請求処理、回収まで、複雑な料金設定、レポートおよびカスタマーポータルといった管理システムを提供します。",
    },
  },
  ability: {
    main_title: "Main Tech Stack",
    sub_title:
      "私たちは情報システムの開発、統合、運用経験があり、以下の技術スタックを持っています。",
    front_end: {
      title: "Front End",
      desc: "React / VUE / TypeScript / JavaScript",
    },
    back_end: {
      title: "Back End",
      desc: "Golang / Nodejs / Python",
    },
    algorithms: {
      title: "Algorithms",
      desc: "C++ / Python / MQL",
    },
    cloud: {
      title: "Cloud Platform",
      desc: "AWS / Azure",
    },
  },
  partner: {
    main_title: "パートナー",
    igent: {
      name: "アイジェント株式会社",
      desc: "オフショア開発を中心に、中国を拠点としたシステム開発支援など企画戦略から運用までワンストップでサポートしております。ベスト・ソリューションパートナーとして、お客様の新しい価値の共創に尽力させていただきます。",
      website: "https://www.igent-tech.com",
    },
    openquant: {
      name: "OpenQuant株式会社",
      desc: "エネルギー業界に向け、トレーディング、人工知能、ストラクチャリングの知識を駆使してこれからのビジネスを実現するITサービス会社です。",
      website: "https://www.open-quant.com",
    },
    hengxun: {
      name: "大連恒迅華成科技株式会社",
      desc: "中国の大連に於けるITサービス会社です。日本に向け、中国国内に向け大規模な開発や派遣は可能です。",
      website: "http://www.hengxun-tech.com",
    },
  },
};
const dicText_cn = {
  menu: {
    home: "home",
    services: "services",
    ability: "tech-stack",
    works: "works",
    company: "company",
    contact: "contact us",
  },
  home: {
    intro_1:
      "在 0 与 1 的信息世界中，发现无穷的可能。<br />搜集既有数据，<br />生成新数据，<br />发现关联数据，以数据创作价值。",
  },
  works: {
    main_title: "Works & Case",
    sub_title: "",
    data_hub_x: {
      title: "DataHubX",
      desc: "灵活地收集各种异构数据，包括Excel文件、CSV文件、PDF文件以及各种数据库。数据被抽取转换并存储为统一的格式，并提供后续的数据再加工，大数据分析以及数据可视化及统计报告生成。",
    },
    strgy_master_pro: {
      title: "StrategyMasterPro",
      desc: "一款交易策略的开发平台。交易标的涵盖股票，期货，外汇，贵金属，数字货币等。<br/> 可以可视化寻找交易思路，量化策略品质，实现交易信号和仓位管理，并可挂载到各交易平台。",
    },
    flex_flow: {
      title: "FlexFlow",
      desc: "一套轻量级可定制的工作流系统，可用于多端数据提交审批复核，也可用于日常办公的经费出勤事务等审批。",
    },
    flex_trading_2: {
      title: "FlexTrading2",
      desc: "一套量化自动交易策略，可以在趋势和震荡走势中自主切换模式，在低风险的前提下获取稳定的可预期收益。",
    },
    customer_ims: {
      title: "顧客管理システム",
      desc: "顧客情報・使用量・電気料金を管理する顧客管理システムです。小売電気事業者様における顧客情報の管理や需給状況の確認、需要家様における使用量の見える化や料金確認機能をご提供します。",
    },
    power_drm: {
      title: "需給管理システム",
      desc: "電力需要予測・電源調達・計画作成を管理する需給管理システムです。AI需要予測、同時同量監視、小売・発電・FIT特例１ポジション、計画提出、JEPXスポットと時間前入札などのフルパッケージ機能をご提供します。",
    },
    power_futures: {
      title: "電力現物・先物管理システム",
      desc: "電力現物取引とそれに付随するデリバティブ取引を管理するコモディティ取引・リスク管理システムです。電力の現物・先物取引・売買管理で生じるポジション管理について、正確かつ効率的に処理することが可能です。",
    },
    power_drs: {
      title: "デマンドレスポンスシステム",
      desc: "電力需要家から実際に使用した電力を収集し、あらかじめ設定したベースラインをクリアしたかを判断するシステムです。需要家へ節電の通知、インセンティブの計算、レポートの抽出を実現します。",
    },
  },
  services: {
    main_title: "Our Services",
    sub_title: "我们围绕数据分析处理，提供上下游周边的咨询与开发实施。",
    data_hub: {
      title: "データ連携・統合基盤の構築",
      desc: "オンプレミスやクラウド環境に分散するデータを管理し、統合ソリューションを導入することで、社内外の様々なシステムのデータ連携を実現します。 様々なフォーマットのデータを収集して、連携先のシステムに適したフォーマットに加工・出力します。",
    },
    algorithms: {
      title: "データ分析・アルゴリズム実装",
      desc: "データ分析を通じて構築されたアルゴリズムをシステムに実装します。多因子时间序列算法开发，金融交易策略的实现以及自动化交易系统的构筑。",
    },
    system_dev: {
      title: "受託開発・運用・保守支援",
      desc: "データ処理システムの新規開発、既存システムの改修などサービスを提供しています。システムのホスティング、システムを監視して安定運転を確保することを行います",
    },
    power_system: {
      title: "電力需給調整・情報管理",
      desc: "送配電網の電圧と周波数を監視し、蓄電キャビネットの充放電を制御して、電網の安定供給を実現するソリューションを提供します。調整力市場に入札、清算システムも提供し、顧客登録から請求処理、回収まで、複雑な料金設定、レポートおよびカスタマーポータルといった管理システムを提供します。",
    },
  },
  ability: {
    main_title: "Main Tech Stack",
    sub_title: "团队有信息系统开发，集成，运维经验，技术栈如下",
    front_end: {
      title: "Front End",
      desc: "React / VUE / TypeScript / JavaScript",
    },
    back_end: {
      title: "Back End",
      desc: "Golang / Nodejs / Python",
    },
    algorithms: {
      title: "Algorithms",
      desc: "C++ / Python / MQL",
    },
    cloud: {
      title: "Cloud Platform",
      desc: "AWS / Azure",
    },
  },
  partner: {
    main_title: "パートナー",
    igent: {
      name: "アイジェント株式会社",
      desc: "オフショア開発を中心に、中国を拠点としたシステム開発支援など企画戦略から運用までワンストップでサポートしております。ベスト・ソリューションパートナーとして、お客様の新しい価値の共創に尽力させていただきます。",
      website: "http://www.igent-tech.com",
    },
    openquant: {
      name: "OpenQuant株式会社",
      desc: "エネルギー業界に向け、トレーディング、人工知能、ストラクチャリングの知識を駆使してこれからのビジネスを実現するITサービス会社です。",
      website: "https://www.open-quant.com",
    },
    hengxun: {
      name: "大連恒迅華成科技株式会社",
      desc: "中国の大連に於けるITサービス会社です。日本に向け、中国国内に向け大規模な開発や派遣は可能です。",
      website: "http://www.hengxun-tech.com",
    },
  },
};
const dicText_en = {
  menu: {
    home: "home",
    services: "services",
    ability: "tech-stack",
    works: "works",
    company: "company",
    contact: "contact us",
  },
  home: {
    intro_1:
      "0と1の情報の世界で、無限の可能性を発見しましょう。<br />既存のデータを収集し、<br />新しいデータを生成し、<br />関連データを見つけ、<br />データを活用して価値を創造しましょう。",
  },
  works: {
    main_title: "Works & Case",
    sub_title: "",
    data_hub_x: {
      title: "DataHubX",
      desc: "Flexibly collect heterogeneous data, including various data formats such as Excel files, CSV files, PDF files, and various databases. Extract and organize the data into a unified format, store it in a database, and provide subsequent data analytics and report generation.",
    },
    strgy_master_pro: {
      title: "StrategyMasterPro",
      desc: "一款交易策略的开发平台。交易标的涵盖股票，期货，外汇，贵金属，数字货币等。<br/> 可以可视化寻找交易思路，量化策略品质，实现交易信号和仓位管理，并可挂载到各交易平台。",
    },
    flex_flow: {
      title: "FlexFlow",
      desc: "一套轻量级可定制的工作流系统，可用于多端数据提交审批复核，也可用于日常办公的经费出勤事务等审批。",
    },
    flex_trading_2: {
      title: "FlexTrading2",
      desc: "一套量化自动交易策略，可以在趋势和震荡走势中自主切换模式，在低风险的前提下获取稳定的可预期收益。",
    },
    strgy_dev: {
      title: "金融取引アルゴリズム、自動取引システムの実装",
      desc: "多因子時系列アルゴリズムの開発、金融取引戦略の実装、および自動取引システムの構築。",
    },
    customer_ims: {
      title: "顧客管理システム",
      desc: "顧客情報・使用量・電気料金を管理する顧客管理システムです。小売電気事業者様における顧客情報の管理や需給状況の確認、需要家様における使用量の見える化や料金確認機能をご提供します。",
    },
    power_drm: {
      title: "需給管理システム",
      desc: "電力需要予測・電源調達・計画作成を管理する需給管理システムです。AI需要予測、同時同量監視、小売・発電・FIT特例１ポジション、計画提出、JEPXスポットと時間前入札などのフルパッケージ機能をご提供します。",
    },
    power_futures: {
      title: "電力現物・先物管理システム",
      desc: "電力現物取引とそれに付随するデリバティブ取引を管理するコモディティ取引・リスク管理システムです。電力の現物・先物取引・売買管理で生じるポジション管理について、正確かつ効率的に処理することが可能です。",
    },
    power_drs: {
      title: "デマンドレスポンスシステム",
      desc: "電力需要家から実際に使用した電力を収集し、あらかじめ設定したベースラインをクリアしたかを判断するシステムです。需要家へ節電の通知、インセンティブの計算、レポートの抽出を実現します。",
    },
  },
  services: {
    main_title: "Our Services",
    sub_title: "我们围绕数据分析处理，提供上下游周边的咨询与开发实施。",
    data_hub: {
      title: "データ連携・統合基盤の構築",
      desc: "オンプレミスやクラウド環境に分散するデータを管理し、統合ソリューションを導入することで、社内外の様々なシステムのデータ連携を実現します。 様々なフォーマットのデータを収集して、連携先のシステムに適したフォーマットに加工・出力します。",
    },
    algorithms: {
      title: "データ分析・アルゴリズム実装",
      desc: "データ分析を通じて構築されたアルゴリズムをシステムに実装します。Development of multi-factor time series algorithms, implementation of financial trading strategies, and construction of an automated trading system.",
    },
    system_dev: {
      title: "受託開発・運用・保守支援",
      desc: "データ処理システムの新規開発、既存システムの改修などサービスを提供しています。システムのホスティング、システムを監視して安定運転を確保することを行います",
    },
    power_system: {
      title: "電力需給調整・情報管理",
      desc: "送配電網の電圧と周波数を監視し、蓄電キャビネットの充放電を制御して、電網の安定供給を実現するソリューションを提供します。調整力市場に入札、清算システムも提供し、顧客登録から請求処理、回収まで、複雑な料金設定、レポートおよびカスタマーポータルといった管理システムを提供します。",
    },
  },
  ability: {
    main_title: "Main Tech Stack",
    sub_title: "团队有信息系统开发，集成，运维经验，技术栈如下",
    front_end: {
      title: "Front End",
      desc: "React / VUE / TypeScript / JavaScript",
    },
    back_end: {
      title: "Back End",
      desc: "Golang / Nodejs / Python",
    },
    algorithms: {
      title: "Algorithms",
      desc: "C++ / Python / MQL",
    },
    cloud: {
      title: "Cloud Platform",
      desc: "AWS / Azure",
    },
  },
  partner: {
    main_title: "パートナー",
    igent: {
      name: "アイジェント株式会社",
      desc: "オフショア開発を中心に、中国を拠点としたシステム開発支援など企画戦略から運用までワンストップでサポートしております。ベスト・ソリューションパートナーとして、お客様の新しい価値の共創に尽力させていただきます。",
      website: "http://www.igent-tech.com",
    },
    openquant: {
      name: "OpenQuant株式会社",
      desc: "エネルギー業界に向け、トレーディング、人工知能、ストラクチャリングの知識を駆使してこれからのビジネスを実現するITサービス会社です。",
      website: "https://www.open-quant.com",
    },
    hengxun: {
      name: "大連恒迅華成科技株式会社",
      desc: "中国の大連に於けるITサービス会社です。日本に向け、中国国内に向け大規模な開発や派遣は可能です。",
      website: "http://www.hengxun-tech.com",
    },
  },
};

let dic = dicText_jp;

const setCurLang = (lang: string) => {
  if (lang === "cn") {
    dic = dicText_cn;
  } else if (lang === "en") {
    dic = dicText_en;
  } else {
    dic = dicText_jp;
  }
};

export { dic, setCurLang };
